import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'newlineWeb' })
export class NewlineOnlyWebPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    if(!value) return '';
    return value.replace(/(?:\r\n|\r|\n)/g, '<br class="only-web">');
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/newlineOnlyWeb.pipe.ts